import Chip from '@mui/material/Chip';

/** Normalize API values: PendingAgent, PriceConfirmed, pending agent, etc. */
export const normalizeFlightQuoteStatus = (status) =>
  (status ?? 'pendingagent')
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, '');

const FLIGHT_QUOTE_STATUS_COLORS = {
  pendingagent: 'warning',
  contacted: 'info',
  quoted: 'primary',
  priceconfirmed: 'success',
  confirmed: 'success',
  booked: 'success',
  cancelled: 'error',
  canceled: 'error',
};

const FLIGHT_QUOTE_STATUS_LABELS = {
  pendingagent: 'Pending Agent',
  contacted: 'Contacted',
  quoted: 'Quoted',
  priceconfirmed: 'Price Confirmed',
  confirmed: 'Confirmed',
  booked: 'Booked',
  cancelled: 'Cancelled',
  canceled: 'Cancelled',
};

export const getFlightQuoteStatusColor = (status) =>
  FLIGHT_QUOTE_STATUS_COLORS[normalizeFlightQuoteStatus(status)] ?? 'default';

export const formatFlightQuoteStatusLabel = (status) => {
  const key = normalizeFlightQuoteStatus(status);
  return FLIGHT_QUOTE_STATUS_LABELS[key] || status?.toString() || 'Pending Agent';
};

export function FlightQuoteStatusChip({ status, size = 'small', sx, ...chipProps }) {
  return (
    <Chip
      label={formatFlightQuoteStatusLabel(status)}
      color={getFlightQuoteStatusColor(status)}
      size={size}
      sx={{ fontWeight: 700, ...sx }}
      {...chipProps}
    />
  );
}
